import React, { Component } from "react";
import PropTypes from "prop-types";
import { shortDate, timeStamp } from "LIB/formatters/date";
import { properCase } from "LIB/formatters/text";
import { TAG_TYPES } from "MODULES/inventories/constants";

export default class AuditTrailTable extends Component {
  static propTypes = {
    auditTrails: PropTypes.arrayOf(PropTypes.instanceOf(Object)).isRequired
  };

  renderRow = (r, idx) => {
    const capitalize = Object.keys(TAG_TYPES).includes(r.action);
    const action = r.action.replace("_uuid", "").replace("_id", "");
    return (
      <tr key={idx}>
        <td>{shortDate(r.created_at)}</td>
        <td>{timeStamp(r.created_at)}</td>
        <td>{capitalize ? action.toUpperCase() : properCase(action)}</td>
        <td>{r.created_by && r.created_by.full_name}</td>
        <td>{properCase(r.previous_value)}</td>
        <td>{properCase(r.new_value)}</td>
      </tr>
    );
  };

  render() {
    return (
      <div>
        <h2>Audit Trail</h2>
        <table className="table table-striped table-hover margin-bottom-none">
          <thead>
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>Action</th>
              <th>Action By</th>
              <th>Previous Value</th>
              <th>New Value</th>
            </tr>
          </thead>
          <tbody>{this.props.auditTrails.map(this.renderRow)}</tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/AuditTrailTable/AuditTrailTable.jsx